

<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  <!-- Filter Datatables -->
  <section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <fieldset class="form-group">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <div>
                        <button [ngClass]="{'btn-primary':activeTab=='Classroom','btn-outline-primary':activeTab!='Classroom'}"
                        id="status-btns" type="button" class="btn btn-outline-primary mr-2"
                        (click)="activeEnrollmentTab('Classroom',0)">Classroom</button>
                      </div>
                      <div>
                        <button [ngClass]="{'btn-primary':activeTab=='Online','btn-outline-primary':activeTab!='Online'}"
                        id="status-btns" type="button" class="btn btn-outline-primary"
                        (click)="activeEnrollmentTab('Online',0)">Online</button>
                      </div>
                    
                    </div>
                  </div>
                  
  
                  <div class="col-12 col-sm-12 col-md-8 col-lg-6 mb-2">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1" *ngIf="user_role.roles=='admin'">
                        <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                          <button type="button" class="btn btn-outline-primary btn2">{{selected_teacherId.name}}</button>
                          <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                            aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Dropdown</span>
                          </button>
                          <div ngbDropdownMenu class="dropdown-menu" role="menu">
                            <button class="dropdown-item" *ngFor="let item of teacher_list"
                              (click)="changeTeacherId(item)">{{item.name}}</button>
                          </div>
                        </div>
                      </div>
                                        </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber"
                      (page)="pageChangeData($event,selected_teacherId)"></ngx-datatable>
                  </div>
                  <!-- <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Student LMS Guideline</button>
                    </div> -->
                 
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
                (page)="pageChangeData($event,selected_teacherId)">
                <ngx-datatable-column name="Student" prop="student">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                    <div class="avatar-img-hover">
                      <img class="rounded-circle mr-1" *ngIf="row?.user_id?.image" [src]="imageUrl + row?.user_id?.image" height="32"
                        width="32" />
                      <div *ngIf="!row?.user_id?.image" class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">{{ row?.user_id?.name | shortName }}</div>
                      </div>
                      <!-- --------- card ------------------------------------ -->
                      <!-- <div  class="card-overlay-on-hover">
                        <div class="card">
                          <div class="card-content">
                            <div class="card-img">
                              <img *ngIf="row?.user_id?.image" class="card-img-top img-fluid" [src]="imageUrl + row?.user_id?.image"
                                alt="Card image cap">
                              <div *ngIf="!row?.user_id?.image" class="avatarImg mr-1 ml-0 bg-primary">
                                <div class="avatar-contentImg">{{ row?.user_id?.name | shortName }}</div>
                              </div>
                            </div>
                            <div class="card-body p-0">
                              <h4>{{row?.name}}</h4>
                              <p *ngIf="!empType.includes('Teacher')">{{row?.user_id?.email}}</p>
                              <p>{{row?.college?.name}}</p>
                              <p *ngIf="!empType.includes('Teacher')">{{row?.user_id?.phone}}</p>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <!-- ---------------------------------------------------------- -->
                    </div>
  
                      <div class="cell-line-height cursor-pointer">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.user_id?.name }} 
                        </p>
                        <span *ngIf="row?.mentor_id" class="badge badge-pill bg-light-info cursor-pointer" placement="top" ngbTooltip="Mentor">
                          {{row?.mentor_id?.name}}
                        </span>
                       
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
    
                <ngx-datatable-column  name="Course Name"
                  prop="course_id">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    {{row?.course_id?.title}}
                  </ng-template>
                </ngx-datatable-column>
               
                <ngx-datatable-column  name="DOJ"
                  prop="doj">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    {{row?.date_of_joining | date: 'dd/MM/yyyy'}}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column  name="Status"
                prop="staus">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span [ngStyle]="{ color: getStatusColor(row?.status) }">
                    {{ row?.status | titlecase }}
                  </span>
                </ng-template>
                
              </ngx-datatable-column>
          
              </ngx-datatable>
        
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  <!--/ Filter Datatables -->
  
  
